import React from 'react'
import { Row } from 'antd'
import {
  ButtonEx,
  CheckIconDiv,
  CheckIconEx,
  MainStep4Div,
  Text
} from '../../shared.style'

const MainStep4 = ({ history }) => {
  return (
    <MainStep4Div>
      <Row justify="center" align="center">
        <CheckIconDiv>
          <CheckIconEx />
        </CheckIconDiv>
      </Row>
      <Row justify="center">
        <Text bold color="#6ebf4b">
          สมัครสมาชิกเรียบร้อยแล้ว
        </Text>
      </Row>
      <Row justify="center">
        <Text color="#6ebf4b">เข้าสู่ระบบ เพื่อจัดการข้อมูล</Text>
      </Row>
      <Row justify="center">
        <ButtonEx
          color="#6ebf4b"
          type="primary"
          onClick={() => {
            history.push('/')
          }}>
          เข้าสู่ระบบ
        </ButtonEx>
      </Row>
    </MainStep4Div>
  )
}

export default MainStep4



// WEBPACK FOOTER //
// ./src/components/MainStep4/index.js